import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import { PropTypes } from 'prop-types';

class WhitePage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			collapsed: false
		};
	};

	onCollapse = () => {
		let active = !this.state.collapsed;
		this.setState({ collapsed: active });
	};

	render() {

		Container.propTypes = {
			fluid:  PropTypes.bool
			// applies .container-fluid class
		};

		Row.propTypes = {
			noGutters: PropTypes.bool
		};

		return(
			<Container fluid={true} className="h-100" id="whitePage">
				<div id="main" className={this.state.collapsed ? 'collapsed' : ''}>
					<main>
						{this.props.children}
					</main>
				</div>
			</Container>
		)
	}
}

export default WhitePage;


// WEBPACK FOOTER //
// ./src/Layout/WhitePage.jsx